import { useQuery } from '@tanstack/react-query';
import ticketsService from '../services/ticketsService';
import { ticketsKeys } from '../queryKeys';

// Catalogos para los desplegables del modulo de tickets. Cambian poco, asi que
// usan un staleTime largo. Cada uno cachea por sede (headquarter en la queryKey).
const STALE_CATALOGO = 10 * 60 * 1000;

// fetcher es un thunk que llama al metodo sobre la instancia (preserva `this`).
const opcionesCatalogo = (queryKey, fetcher, headquarter) => ({
  queryKey,
  queryFn: async () => {
    const data = await fetcher();
    return Array.isArray(data) ? data : [];
  },
  enabled: Boolean(headquarter),
  staleTime: STALE_CATALOGO,
});

export const useEstados = (headquarter) =>
  useQuery(
    opcionesCatalogo(
      ticketsKeys.estados(headquarter),
      () => ticketsService.listarEstados({ headquarter }),
      headquarter,
    ),
  );

export const useGrupos = (headquarter) =>
  useQuery(
    opcionesCatalogo(
      ticketsKeys.grupos(headquarter),
      () => ticketsService.listarGrupos({ headquarter }),
      headquarter,
    ),
  );

export const useTemas = (headquarter) =>
  useQuery(
    opcionesCatalogo(
      ticketsKeys.temas(headquarter),
      () => ticketsService.listarTemas({ headquarter }),
      headquarter,
    ),
  );

export const useEtiquetas = (headquarter) =>
  useQuery(
    opcionesCatalogo(
      ticketsKeys.etiquetas(headquarter),
      () => ticketsService.listarEtiquetas({ headquarter }),
      headquarter,
    ),
  );
